import * as React from 'react';
import HeaderFlexPane from './HeaderFlexPane';
import HeaderPaneProps from './HeaderPaneProps';
import strings from 'owa-strings/owa-options-strings';
import { QuickOptions } from 'owa-options-view';
import { observer } from 'mobx-react';

@observer
export default class SettingsPane extends React.Component<HeaderPaneProps, {}> {
    render() {
        return (
            <HeaderFlexPane
                title={() => strings.optionsFlex_title}
                content={<QuickOptions onDismiss={this.props.onDismiss} />}
                onDismiss={this.props.onDismiss}
            />
        );
    }
}
